const normalizeStatus = (status) => {
  if (status === null || status === undefined) {
    return '';
  }

  return String(status).trim().toLowerCase();
};

export const classifyMeasureCheckpointStatus = (status) => {
  const normalizedStatus = normalizeStatus(status);

  if (!normalizedStatus) {
    return 'noStatus';
  }

  switch (normalizedStatus) {
    case 'gestoppt':
    case 'schwierigkeiten':
      return 'stopped';
    case 'nicht begonnen':
      return 'notStarted';
    case 'in bearbeitung - verzögert':
    case 'verzögert':
      return 'delayedProgress';
    case 'in bearbeitung - nach plan':
    case 'planmäßig':
      return 'onTrackProgress';
    case 'abgeschlossen':
      return 'completed';
    default:
      return 'noStatus';
  }
};

export const classifyActionAreaCheckpointStatus = (status) => {
  const normalizedStatus = normalizeStatus(status);

  if (!normalizedStatus) {
    return 'noStatus';
  }

  switch (normalizedStatus) {
    case 'nicht erreicht':
      return 'notAchieved';
    case 'erreicht':
      return 'partiallyAchieved';
    case 'mehr als erreicht':
      return 'achieved';
    default:
      return 'noStatus';
  }
};

export const createMeasureCheckpointCounts = () => ({
  noStatusCount: 0,
  stoppedCount: 0,
  notStartedCount: 0,
  delayedProgressCount: 0,
  onTrackProgressCount: 0,
  completedCount: 0,
  totalMeasures: 0,
});

export const addMeasureCheckpointStatusCount = (counts, status) => {
  counts.totalMeasures += 1;

  switch (classifyMeasureCheckpointStatus(status)) {
    case 'stopped':
      counts.stoppedCount += 1;
      break;
    case 'notStarted':
      counts.notStartedCount += 1;
      break;
    case 'delayedProgress':
      counts.delayedProgressCount += 1;
      break;
    case 'onTrackProgress':
      counts.onTrackProgressCount += 1;
      break;
    case 'completed':
      counts.completedCount += 1;
      break;
    default:
      counts.noStatusCount += 1;
      break;
  }
};

export const createActionAreaCheckpointCounts = () => ({
  noStatus: 0,
  notAchieved: 0,
  partiallyAchieved: 0,
  achieved: 0,
  total: 0,
});

export const addActionAreaCheckpointStatusCount = (counts, status) => {
  counts.total += 1;

  switch (classifyActionAreaCheckpointStatus(status)) {
    case 'notAchieved':
      counts.notAchieved += 1;
      break;
    case 'partiallyAchieved':
      counts.partiallyAchieved += 1;
      break;
    case 'achieved':
      counts.achieved += 1;
      break;
    default:
      counts.noStatus += 1;
      break;
  }
};
